
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/bulkupdate",
      function () {
        return require("private-next-pages/products/bulkupdate.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/bulkupdate"])
      });
    }
  